export function MediamarktPrivacyDE() {
  return (
    <article>
      <h1>Datenschutzrichtlinie</h1>
      <time dateTime="2024-09-01">September 2024</time>

      <div>
        <p>
          Diese Datenschutzrichtlinie gilt für alle von Jotta AS (Jottacloud)
          angebotenen Produkte, Dienstleistungen und Websites. Die Begriffe
          „wir“, „unser“ und „uns“ beziehen sich auf Jottacloud, während sich
          „Sie“ und „Ihr“ auf den Jottacloud-Kunden oder -Nutzer beziehen.
        </p>
        <h3>Die von uns gesammelten Informationen</h3>
        <p>
          Wenn Sie die Dienste und Websites von Jottacloud besuchen, stellen Sie
          uns zwei Arten von Informationen zur Verfügung: Personenbezogene
          Daten, die Sie wissentlich offen legen und die von uns erfasst werden,
          und Informationen zur Website-Nutzung, die von uns erfasst werden,
          wenn Sie mit unseren Diensten interagieren.
        </p>
        <h3>Von Ihnen bereitgestellte Informationen</h3>
        <p>
          Wenn Sie sich bei Jottacloud registrieren, geben Sie Ihren Namen, Ihre
          E-Mail-Adresse und Ihre Telefonnummer an, im Folgenden als
          „personenbezogene Daten“ bezeichnet.
        </p>
        <p>
          Passwörter werden in unseren Datenbanken verschlüsselt. Wir können Ihr
          Passwort nicht lesen. Jottacloud hat keinen Zugriff auf Ihre
          Kreditkarteninformationen.
        </p>
        <p>
          Wenn Sie ein registrierter Benutzer von Jottacloud sind, erkennen Sie
          an und stimmen zu, dass Jottacloud Ihnen gelegentlich wichtige
          Mitteilungen bezüglich Ihres Kontos oder des Dienstes per E-Mail oder
          SMS senden kann.
        </p>
        <h3>Informationen zur Website-Nutzung</h3>
        <p>
          Wenn Sie Jottacloud aufrufen, erfassen wir Ihren Browsertyp und Ihre
          IP-Adresse. Diese Informationen werden für alle Besucher und Nutzer
          von Jottacloud erfasst. Darüber hinaus speichern wir bestimmte
          Informationen Ihres Browsers mithilfe von „Cookies“. Ein Cookie ist
          ein auf dem Computer des Nutzers gespeichertes Datenelement, das mit
          Informationen über den Nutzer verknüpft ist. Wir verwenden
          Session-ID-Cookies, um zu bestätigen, dass registrierte Nutzer
          angemeldet sind.
        </p>
        <p>
          Wir verwenden dauerhafte Cookies, um Informationen zur Website-Nutzung
          zu speichern. Dauerhafte Cookies werden für einen längeren Zeitraum
          auf Ihrem Computer gespeichert. Diese Informationen sind nicht
          persönlich identifizierbar.
        </p>
        <h3>Hochladen von Daten</h3>
        <p>
          Wenn Sie Dateien in Jottacloud hochladen, senden Sie auch
          Dateisysteminformationen, einschließlich Datei- und Verzeichnisnamen.
          Die Dateien werden während der Übertragung mit Secure Socket Layer
          (SSL) verschlüsselt.
        </p>
        <h3>Wie wir die Informationen verwenden</h3>
        <ul>
          <li>
            Wir verwenden die von uns gesammelten Informationen, um den
            Benutzern qualitativ hochwertige Dienste bereitzustellen und neue
            Produkte und Dienste für unsere Kunden und potenziellen Kunden zu
            entwickeln.
          </li>
          <li>
            Wir können die Metadaten Ihres Dateisystems (Dateiname, Größe usw.,
            jedoch nicht den Dateiinhalt) einsehen, um technischen Support zu
            leisten.
          </li>
          <li>
            Wir werden Ihre E-Mail-Adresse weder verkaufen noch vermarkten.
          </li>
          <li>
            Wir geben Ihre personenbezogenen Daten nicht an Dritte weiter.
          </li>
          <li>
            Wir werden die Dateien, die Sie in Jottacloud hochladen, nicht
            einsehen.
          </li>
        </ul>
        <h3>Kinder unter 13 Jahren</h3>
        <p>
          Kinder unter 13 Jahren dürfen sich nicht bei Jottacloud registrieren.
          Jottacloud sammelt oder erfragt nicht wissentlich personenbezogene
          Daten von Personen unter 13 Jahren und erlaubt solchen Personen nicht
          wissentlich die Registrierung.
        </p>
        <h3>Sicherheit</h3>
        <p>
          Wir verwenden branchenübliche Sicherheitsmaßnahmen, um die in unserer
          Verfügung befindlichen Informationen vor Verlust, Missbrauch und
          Veränderung zu schützen.
        </p>
        <p>
          Da E-Mail und Instant Messaging nicht als sichere Kommunikationsmittel
          gelten, bitten wir Sie, uns keine sensiblen personenbezogenen Daten
          per E-Mail oder über Instant Messaging-Dienste zu senden.
        </p>
        <p>
          Wenn Sie Ihr Konto kündigen, können Ihre Daten und sonstigen
          Informationen bis zur Löschung nach 90 Tagen in unserem Archiv oder
          Sicherungsdatensatz gespeichert bleiben.
        </p>
        <h3>Links</h3>
        <p>
          Jottacloud kann Links zu anderen Websites enthalten. Wir sind nicht
          für die Datenschutzpraktiken anderer Websites verantwortlich. Diese
          Datenschutzrichtlinie gilt ausschließlich für von Jottacloud erfasste
          Informationen.
        </p>
        <h3>Zugriff, Änderung und Löschung personenbezogener Daten</h3>
        <p>
          Sie haben das Recht, Auskunft über die von uns verarbeiteten
          personenbezogenen Daten zu verlangen und diese zu korrigieren oder zu
          löschen. Sie haben außerdem das Recht auf Einschränkung der
          Verarbeitung, Widerspruch gegen die Verarbeitung und das Recht auf
          Datenübertragbarkeit. Sie können Ihre Einwilligung zur Verarbeitung
          personenbezogener Daten jederzeit widerrufen.
        </p>
        <p>
          Weitere Informationen zum Inhalt dieser Rechte finden Sie auf der
          Website der Datenschutzbehörde:
          <a
            href="https://www.datatilsynet.no"
            rel="nofollow noopener noreferrer"
            target="_blank"
          >
            https://www.datatilsynet.no
          </a>
          .
        </p>
        <p>
          Zur Nutzung unserer Dienste ist Ihre Zustimmung zur Speicherung
          personenbezogener Daten erforderlich.
        </p>
        <h3>Beschwerden</h3>
        <p>
          Wenn Sie der Meinung sind, dass unsere Verarbeitung personenbezogener
          Daten nicht der hier beschriebenen entspricht oder wir anderweitig
          gegen Datenschutzgesetze verstoßen, können Sie sich an die
          Datenschutzbehörde wenden. Informationen zur Kontaktaufnahme mit der
          Datenschutzbehörde finden Sie auf deren Website:{' '}
          <a
            href="https://www.datatilsynet.no"
            rel="nofollow noopener noreferrer"
            target="_blank"
          >
            https://www.datatilsynet.no
          </a>
          .
        </p>

        <h3>Änderungen dieser Richtlinie</h3>
        <p>
          Jottacloud behält sich das Recht vor, diese Richtlinie jederzeit nach
          eigenem Ermessen zu überarbeiten, zu ergänzen oder zu modifizieren.
          Hinweise auf Überarbeitungen, Ergänzungen oder Modifikationen dieser
          Richtlinie werden auf den Jottacloud-Websites veröffentlicht. Die
          fortgesetzte Nutzung des Dienstes durch den Nutzer gilt als Zustimmung
          zu diesen Änderungen. Benachrichtigungen über die oben genannten
          Änderungen werden dem Nutzer per E-Mail zugesandt.
        </p>
      </div>
    </article>
  )
}
